import React, { useState } from "react";
import Section from "../components/Section";
import TabBar from "../components/services/TabBar";
import IndividualsTab from "../components/services/IndividualsTab";
import BusinessOwnersTab from "../components/services/BusinessOwnersTab";
import InstitutionsTab from "../components/services/InstitutionsTab";
import { BRAND } from "../config/brandConfig";

function ServicesPage() {
  const [activeTab, setActiveTab] = useState("individuals");

  return (
    <div>
      <Section
        eyebrow="Services"
        title="Specialized Wealth Management for Complex Balance Sheets."
        kicker="Your company and personal finances should reinforce each other, not compete for attention. We provide the comprehensive services required for cohesive wealth management."
      >
        {/* VANGUARD LINE (SAGE 2) */}
        <p
          style={{
            fontSize: 16,
            fontWeight: 500,
            color: "#334155",
            marginBottom: "1.5rem",
            maxWidth: 640,
          }}
        >
          Wealth management isn’t about prediction. It’s about consistency.
        </p>

        <TabBar activeTab={activeTab} setActiveTab={setActiveTab} />
        <div style={{ marginTop: "1.5rem", marginBottom: "3rem" }}>
          {activeTab === "individuals" && <IndividualsTab />}
          {activeTab === "business" && <BusinessOwnersTab />}
          {activeTab === "institutions" && <InstitutionsTab />}
        </div>
      </Section>

      {/* SAGE 4 (UBS) WEALTH ARCHITECTURE SECTION */}
      <Section
        eyebrow="High Complexity"
        title="Coordinated Wealth Architecture."
        kicker="Complex wealth deserves a coordinated strategy. We ensure all components of your financial life work in concert."
      >
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
            gap: "1.25rem",
          }}
        >
          {[
            "Entities & Trusts",
            "Taxes across Jurisdictions",
            "Concentrated Stock Management",
            "Liquidity & Cash Flow Planning",
            "Risk Transfer Strategies",
            "Succession & Governance",
            "Cross-Adviser Coordination",
            "Business and Personal Capital Flows",
          ].map((item, index) => (
            <div
              key={index}
              style={{
                fontSize: 14,
                color: "#0f172a",
                fontWeight: 600,
                padding: "0.75rem 1rem",
                border: "1px solid rgba(148,163,184,0.3)",
                borderRadius: 12,
                backgroundColor: "#ffffff",
              }}
            >
              {item}
            </div>
          ))}
        </div>
      </Section>
      {/* END SAGE 4 SECTION */}
    </div>
  );
}

export default ServicesPage;
